import { FaRegEdit } from "react-icons/fa";

import Button from "components/Buttons";
import { HomeIcon, MailIcon, PhoneIcon } from "components/Icons";

import verified from "assets/images/verified.png";
import ScaleIcon from "assets/icons/scale.svg?react";
import ProfileDefaultImage from "assets/icons/default_avater.svg";

import { formatName, formatPhoneNumber } from "utils";

import { useNotificationSettings } from "hooks/useNotificationSettings";
import { useProfileStore } from "stores/profile/useProfileStore";
import { usePhoneVerification } from "hooks/usePhoneVerification";
import { useProfileForm } from "hooks/useProfileForm";
import { useModalStore, Modal } from "stores/modal/useModalStore";
import { useAuthStore } from "stores/auth/authStore";

const ProfileInfo = () => {
  const { open } = useModalStore();
  
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);
  
  const methods = useProfileForm(user);
  const imageResult = useProfileStore((state) => state.imageResult);

  const { selectedOption, handleOptionChange } = useNotificationSettings(user);
  const { onVerifyCodeModal } = usePhoneVerification(
    user,
    () => methods.getValues()?.phone
  );

  const openModalHandler = () => {
    open(Modal.Profile);
  };

  return (
    <div className="mb-[120px] mt-[126px] w-[90%] px-5 xl:max-w-[1300px] mx-auto">
      <div className="flex items-center w-full gap-[10px] sm:gap-[31px]">
        <div className="relative">
          {!isLoading && (
            <>
              <img
                src={
                  imageResult
                    ? imageResult
                    : user?.photo
                    ? user?.photo
                    : ProfileDefaultImage
                }
                alt="profile image"
                className="profile-pic max-w-[85px] min-h-[85px] rounded-full"
              />
            </>
          )}
        </div>
        <div className="flex items-center w-full justify-between gap-[20px]">
          <h2 className="client-name_title">
            {formatName(user?.firstName + " " + user?.lastName) ||
              "Steve Smith"}
          </h2>

          <Button
            whiteOutline
            primary
            className={`!w-[110px] sm:!w-[140px] !h-[35px] sm:!h-[40px] !rounded-[56px] flex lg:!hidden items-center !gap-x-2 !font-[montserrat] !text-[12px] sm:!text-[14px] !bg-[#2B364B] !text-white`}
            onClick={openModalHandler}
          >
            Edit Profile
            <FaRegEdit className="!cursor-pointer ml-2" />
          </Button>
        </div>
      </div>
      <div className="mt-[35px]">
        <div className="flex flex-row items-center gap-10">
          <p className="contact_text capitalize">Personal Information</p>
          <Button
            whiteOutline
            primary
            className={`!w-[110px] sm:!w-[140px] !h-[35px] sm:!h-[40px] !rounded-[56px] !hidden lg:!flex items-center !gap-x-2 !font-[montserrat] !text-[12px] sm:!text-[14px] !bg-[#2B364B] !text-white`}
            onClick={openModalHandler}
          >
            Edit Profile
            <FaRegEdit className="!cursor-pointer ml-2" />
          </Button>
        </div>
        <div className="flex flex-wrap mt-[44px] gap-[20px] xl:gap-[35px]">
          <div className="flex items-center flex-wrap gap-[18px]">
            <>
              <MailIcon className="!text-transparent !cursor-pointer" />
              <p className="contact_info">{user?.email}</p>
            </>
            <div className="flex items-center gap-2 lg:gap-[18px]">
              <PhoneIcon className="!text-transparent !cursor-pointer" />

              <p className="contact_info">{formatPhoneNumber(user?.phone)}</p>

              <div className="flex items-center gap-x-3">
                {user?.isPhoneVerified && (
                  <img src={verified} alt="verified" className="w-5 h-5" />
                )}

                {!user?.isPhoneVerified && user?.phone?.length ? (
                  <Button
                    className={`phone-verify_btn !w-[10px] !h-[10px]  bg-white border-2 border-[#2B364B]  text-[#2B364B]`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onVerifyCodeModal();
                    }}
                  >
                    Verify
                  </Button>
                ) : null}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-[11px]">
            <ScaleIcon />
            <p className="seat_size_info">
              {user?.size?.length
                ? `${String(user.size).replace(/,/g, ", ")}” Saddle Size`
                : "No Seat Size Selected"}
            </p>
          </div>

          <div className="flex items-center flex-wrap gap-[8px] md:gap-[18px]">
            <HomeIcon className="!text-transparent !cursor-pointer" />

            <p className="contact_info w-[250px] sm:w-auto">
              {user?.address && `${user.address}, `}
              {user?.state && `${user.state}, `}
              {user?.suiteOrApt && `${user.suiteOrApt}, `}
              {user?.zipCode && `${user.zipCode}, `}
              {user?.city && `${user.city}, `}
              {user?.country && `${user.country}`}
            </p>
          </div>
        </div>
        <div className="mt-10">
          <p className="notification-settings capitalize">
            Notification Settings
          </p>

          <form className="mt-5">
            <div className="space-x-2 cursor-pointer">
              <input
                type="radio"
                id="email"
                name="option"
                value="email"
                checked={selectedOption === "email"}
                onChange={handleOptionChange}
                className="cursor-pointer"
                // disabled={clientData?.user?.notification !== "email"}
              />
              <label
                htmlFor="email"
                className={`label-text cursor-pointer ${
                  user?.notification !== "email" && "text-gray-600"
                }`}
              >
                Email
              </label>
            </div>
            <div className="space-x-2 cursor-pointer">
              <input
                type="radio"
                id="phone"
                name="option"
                value="phone"
                className="cursor-pointer"
                checked={selectedOption === "phone"}
                onChange={handleOptionChange}
                // disabled={clientData?.user?.notification !== "phone"}
              />
              <label
                htmlFor="phone"
                className={`label-text cursor-pointer ${
                  user?.notification !== "phone" && "text-gray-600"
                }`}
              >
                Phone Number
              </label>
            </div>
            <div className="space-x-2 cursor-pointer">
              <input
                type="radio"
                id="both"
                name="option"
                value="both"
                checked={selectedOption === "both"}
                onChange={handleOptionChange}
                className="cursor-pointer"
                // disabled={clientData?.user?.notification !== "both"}
              />
              <label
                htmlFor="both"
                className={`label-text cursor-pointer ${
                  user?.notification !== "both" && "text-gray-600"
                }`}
              >
                Both
              </label>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;